// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1PB0M","colMaxWidth":"Table_colMaxWidth__e6PK8"};